export default __webpack_public_path__ + "static/housewarming-gift-video-6fede6d050210f711916f96ba0658f79.webp";